//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  saveAs
} from 'file-saver'
import '@/mixins/global'
import axios from 'axios'

import Page07NewEASub from '../components/Page07NewEASub'

export default {
  components: {
    Page07NewEASub
  },

  data () {
    return {
      pagename: 'Page07New',
      tab: 'pcs',
      scrollTarget: 10,
      visible1: false,
      Refresh: true,
      viewsoclosed: 'N',
      viewexclosed: 'N',
      viewfgclosed: 'N',
      viewqaclosed: 'N',
      date: '',
      curperiod: '',
      periods: [],
      customer: '',
      customers: [],
      brand: '',
      brands: [],
      status: 'ALL',
      viewstatus: 'Actual',
      ws: '',
      we: '',
      sono: '',
      loc: [],
      locs: ['G1', 'G2', 'G3', 'G4', 'GW', 'NYV1', 'TRM'],
      closestatus: [],
      closestatuss: ['PPC_CLOSE_SO', 'PPC_CLOSE_EXPORT', 'CLOSE_FG', 'CLOSE_QA_FINAL'],
      search1: {
        ws: '',
        we: ''
      }
    }
  },
  created () {
    this.CheckLocal()
    this.LoadFirst()

    // this.LoadPeriod()
  },
  async mounted () {
    this.LoadCustomer()
    this.LoadBrand()
    this.getlocarray()
    await new Promise(resolve => setTimeout(resolve, 1200))

    let a = await this.LoadPeriodDefault()
    let b = await this.LoadPeriod()
  },
  watch: {
    loc: function (newValue, oldValue) {},
    customer: function (newValue, oldValue) {},
    status: function (newValue, oldValue) {
      this.LoadPeriod()
    },
    viewstatus: function (newValue, oldValue) {}
  },
  computed: {},
  methods: {
    LoadFirst () {
      this.pulling = setTimeout(() => {
        this.chkAuthen('', '')
        this.pullData()
      }, 1000)
    },

    keeplocation () {
      // console.log(this.loc);
      const postjson = {
        authen: { keycode: this.$keycode },
        input: {
          uid: this.$store.getters.uid,
          syscode: this.$syscode,
          pagename: this.pagename,
          loc: this.loc
        }
      }

      axios({
        method: 'post',
        url: `${this.$apiflask}/log/keeplocarray`, // php
        data: postjson
      }).then(res => {
        this.LoadPeriod()
      })
    },

    getclosed () {
      this.LoadPeriod()
    },

    getlocarray () {
      this.Refresh = false
      const postjson = {
        authen: { keycode: this.$keycode },
        input: {
          uid: this.$store.getters.uid,
          syscode: this.$syscode,
          pagename: this.pagename
        }
      }
      axios({
        method: 'post',
        url: `${this.$apiflask}/log/getlocarray`,
        data: postjson
      }).then(res => {
        if (res.data.length === 0) {
          this.loc = this.locs
        } else {
          this.loc = res.data
        }
      })
    },

    goPeriod () {
      this.pulling = setTimeout(() => {
        this.$refs.virtualListRef.scrollTo(14)
      }, 2000)
    },
    pullData () {
      this.pulling = setInterval(() => {
        var currentdate = new Date()
        if (
          currentdate.getMinutes() % 30 === 0 &&
          currentdate.getSeconds() === 0
        ) {
          this.LoadPeriod()
        }
        // console.log(currentdate)
      }, 1000)
    },

    async LoadCustomer () {
      this.Refresh = false
      const postjson = { authen: { keycode: this.$keycode } }
      await axios({
        method: 'post',
        url: `${this.$apiflask}/nygctroom/board7/customers_new`,
        data: postjson
      }).then(res => {
        // console.log(res.data);
        this.customers = res.data
        this.loading = false
      })
    },

    async LoadBrand () {
      this.Refresh = false
      const postjson = { authen: { keycode: this.$keycode } }
      await axios({
        method: 'post',
        url: `${this.$apiflask}/nygctroom/board7/brands_new`,
        data: postjson
      }).then(res => {
        // console.log(res.data);
        this.brands = res.data
        this.loading = false
      })
    },

    async LoadPeriodDefault () {
      const postjson = { authen: { keycode: this.$keycode } }
      await axios({
        method: 'post',
        url: `${this.$apiflask}/nygctroom/board7/defaultweek`,
        data: postjson
      }).then(res => {
        // console.log(res.data);
        this.ws = res.data.ps
        this.we = res.data.pe
        this.curperiod = res.data.pc
      })
    },

    LoadPeriod () {
      this.Refresh = false
      // console.log(this.periodType);
      const postjson = {
        authen: { keycode: this.$keycode },
        filter: {
          ps: this.ws,
          pe: this.we
        }
      }
      const obj = axios({
        method: 'post',
        url: `${this.$apiflask}/nygctroom/board7/period`,
        data: postjson
      }).then(res => {
        // console.log(res.data);
        this.periods = res.data
        this.Refresh = true
        this.goPeriod()
      })

      return obj
    },

    exportExcelSOSub () {
      if (this.search1.ws === '' || this.search1.we === '') {
        this.$q.notify({
          position: 'top-right',
          timeout: 2500,
          textColor: 'white',
          color: 'red',
          message: 'Please fill Week!',
          html: true
        })
        return false
      } else {
        // window.open(
        //   `${this.$apiflask}nyg_ppr_planship_new/${this.search1.ws}/${
        //     this.search1.we
        //   }?uuid=${this.create_UUID()}`,
        //   '_export'
        // )
        // window.open(
        //   `${this.$apiFix}page07_newea.php/nyg_ppr_planship_new_ea`
        // )
        this.Excel_Detail()
      }
    },
    exportExcelSOSubSub () {
      if (this.search1.ws === '' || this.search1.we === '') {
        this.$q.notify({
          position: 'top-right',
          timeout: 2500,
          textColor: 'white',
          color: 'red',
          message: 'Please fill Week!',
          html: true
        })
        return false
      } else {
        this.Excel_Detail_Sub()
      }
    },
    getClassSize () {
      if (this.$q.screen.width <= 1440) {
        return 'text-h4 fnt'
      } else {
        return 'text-h3 fnt'
      }
    },
    getClassSize2 () {
      if (this.$q.screen.width <= 1440) {
        return 'text-h5 fnt'
      } else {
        return 'text-h4 fnt'
      }
    },
    Excel_Detail () {
      this.visible1 = true
      let pathapi = 'http://127.0.0.1:9000/nygcontrolroom_x/api/'
      pathapi = this.$apiFix
      const params = new FormData()
      params.append('ws', this.search1.ws)
      params.append('we', this.search1.we)
      params.append('loc', this.loc)
      params.append('closestatus', this.closestatus)
      void axios({
        method: 'post',
        url: `${pathapi}page07_newea.php/nyg_ppr_planship_new_ea`,
        data: params
      }).then(res => {
        // console.log(res.data)
        if (res.data.dt_sql.length > 0) {
          this.json_excel = res.data.dt_sql
          this.onExport()
        } else {
          alert('Please Check Date')
        }
        this.visible1 = false
      }).catch(error => {
        alert(error)
      })
    },
    Excel_Detail_Sub () {
      this.visible1 = true
      let pathapi = 'http://127.0.0.1:9000/nygcontrolroom_x/api/'
      pathapi = this.$apiFix
      const params = new FormData()
      params.append('ws', this.search1.ws)
      params.append('we', this.search1.we)
      params.append('loc', this.loc)
      params.append('closestatus', this.closestatus)
      void axios({
        method: 'post',
        url: `${pathapi}page07_newea.php/nyg_ppr_planship_new_ea_sub`,
        data: params
      }).then(res => {
        // console.log(res.data)
        if (res.data.dt_sql.length > 0) {
          this.json_excel = res.data.dt_sql
          this.onExportSub()
        } else {
          alert('Please Check Date')
        }
        this.visible1 = false
      }).catch(error => {
        alert(error)
      })
    },
    onExport () {
      // eslint-disable-next-line camelcase
      let key_name = Object.keys(this.json_excel[0])
      // let columns_width = []
      // console.log(key_name)
      const ExcelJS = require('exceljs')
      const wb = new ExcelJS.Workbook()
      const ws = wb.addWorksheet('Sheet1')
      // eslint-disable-next-line camelcase
      let col_num = 1
      key_name.forEach(e => {
        // columns_width.push({
        //   width: 20
        // })
        // ws.getCell(1, col_num).fill = {
        //   type: 'pattern',
        //   pattern: 'solid'
        //   ,fgColor: {
        //     argb: 'E0E0E0'
        //   }
        // }
        ws.getCell(1, col_num).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        }
        ws.getCell(1, col_num).value = e
        ws.getCell(1, col_num).font = {
          // family: 4,
          // size: 14,
          // underline: true,
          bold: true
        }
        ws.getCell(1, col_num).alignment = {
          vertical: 'middle',
          horizontal: 'center'
        }

        // eslint-disable-next-line camelcase
        col_num++
      })
      // eslint-disable-next-line camelcase
      let row_num = 2
      // eslint-disable-next-line camelcase, no-unused-vars
      this.json_excel.forEach(x => {
        // eslint-disable-next-line camelcase, no-unused-vars
        let col_body = 1
        key_name.forEach(e => {
          // eslint-disable-next-line camelcase, no-undef SYSITSDADMIN
          ws.getCell(row_num, col_body).value = x[e]
          // eslint-disable-next-line camelcase, no-undef
          col_body++
        })

        // eslint-disable-next-line camelcase
        row_num++
        // eslint-disable-next-line camelcase
        col_body = 1
      })

      // eslint-disable-next-line camelcase
      // ws.columns = columns_width
      wb.xlsx.writeBuffer().then((data) => {
        const blob = new Blob([data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        })
        saveAs(blob, 'ExportShipmentSub1_newEA.xlsx')
      })
    },
    onExportSub () {
      // eslint-disable-next-line camelcase
      let key_name = Object.keys(this.json_excel[0])
      // let columns_width = []
      // console.log(key_name)
      const ExcelJS = require('exceljs')
      const wb = new ExcelJS.Workbook()
      const ws = wb.addWorksheet('Sheet1')
      // eslint-disable-next-line camelcase
      let col_num = 1
      key_name.forEach(e => {
        ws.getCell(1, col_num).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        }
        ws.getCell(1, col_num).value = e
        ws.getCell(1, col_num).font = {
          bold: true
        }
        ws.getCell(1, col_num).alignment = {
          vertical: 'middle',
          horizontal: 'center'
        }

        // eslint-disable-next-line camelcase
        col_num++
      })
      // eslint-disable-next-line camelcase
      let row_num = 2
      // eslint-disable-next-line camelcase, no-unused-vars
      this.json_excel.forEach(x => {
        // eslint-disable-next-line camelcase, no-unused-vars
        let col_body = 1
        key_name.forEach(e => {
          // eslint-disable-next-line camelcase, no-undef SYSITSDADMIN
          ws.getCell(row_num, col_body).value = x[e]
          // eslint-disable-next-line camelcase, no-undef
          col_body++
        })

        // eslint-disable-next-line camelcase
        row_num++
        // eslint-disable-next-line camelcase
        col_body = 1
      })

      // eslint-disable-next-line camelcase
      // ws.columns = columns_width
      wb.xlsx.writeBuffer().then((data) => {
        const blob = new Blob([data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        })
        saveAs(blob, 'ExportShipmentSub1_newEASub.xlsx')
      })
    }
    // goPeriod() {
    //   var elmnt = document.getElementById("WK-202030");
    //   elmnt.scrollIntoView();
    // }
  }
}
